import { CompactTabItem } from 'components/nav/CompactTabMenu/CompactTab';

import { ImageSpecsModel } from '../models/formula.model';
import { PushProviders } from '../models/pushProvider.model';

export const CONTROLLED_FORMULA_BUFFER = 30;
export const CONTROLLED_FORMULA_CANCEL_BUFFER = 20;
export const CONTROLLED_FORMULA_EXCEED_BUFFER_TIME_TOOLTIP =
    "Message has been sent to most of the users, so it can't be cancelled now.";

export const FORMULA_IMAGE_SPEC_DATA: {
    [type in PushProviders]?: ImageSpecsModel;
} = {
    [PushProviders.Braze]: {
        heading: 'Delivery provider image requirements',
        specs: {
            aspect_ratio: '29:10',
            resolution: '1450 x 500 px',
            minimum_resolution: '600 x 205 px',
            file_types: 'PNG, JPG and GIF',
        },
    },
    [PushProviders.CleverTap]: {
        heading: 'Delivery provider image requirements',
        specs: {
            aspect_ratio: '2:1',
            resolution: '1024 x 512 px',
            minimum_resolution: '512 x 256 px',
            file_types: 'PNG, JPG and GIF',
        },
    },
    [PushProviders.OneSignal]: {
        heading: 'Delivery provider image requirements',
        specs: {
            aspect_ratio: '16:9, 4:3 or 3:2',
            resolution: '1440 x 720 px',
            minimum_resolution: '512 x 256 px',
            file_types: 'PNG, JPG and GIF',
        },
    },
};

export const CONTROLLED_FORMULA_SCHEDULED_DATE_PASS_TOOLTIP =
    'This message has already been sent. To reuse it, try cloning.';
export const CONTROLLED_ARCHIVED_FORMULA_SCHEDULED_DATE_PASS_TOOLTIP =
    'The schedule time for this message has passed. To reuse it, try cloning.';

export const HEADER_TOOLTIP_CONTENT =
    'This is the character count including the longest variant in this message.';

export const PROCEED_SENDING = 'Proceed sending';

export enum FormulaTestMessageType {
    OneUser = 'one_user',
    GroupUser = 'group_user',
}
export enum DrawerTabOptions {
    summary = 'summary',
    content = 'content',
    trail = 'trail',
}
export const DRAWERTABS: CompactTabItem[] = [
    { name: 'Summary', key: DrawerTabOptions.summary, isPrimary: true },
    { name: 'Content', key: DrawerTabOptions.content, isPrimary: false },
    { name: 'Trail', key: DrawerTabOptions.trail, isPrimary: false },
];
export const UNTITLED_MESSAGE = 'Untitled Message';
